/* Urban Lux CRO Scripts */

(function(){
  'use strict';

  /* ── SOCIAL PROOF POPUP ── */
  var proofs = [
    { name: 'Laura M. (Madrid)', text: 'acaba de comprar el Cepillo Limpiador Facial', time: 'hace 3 min' },
    { name: 'Carlos R. (Barcelona)', text: 'acaba de comprar el Sérum Vitamina C', time: 'hace 7 min' },
    { name: 'Ana G. (Valencia)', text: 'acaba de comprar el Pack Rutina Completa', time: 'hace 12 min' },
    { name: 'Marta F. (Sevilla)', text: 'acaba de comprar el Roller de Jade', time: 'hace 18 min' },
    { name: 'Pedro S. (Bilbao)', text: 'acaba de comprar el Masajeador LED', time: 'hace 22 min' }
  ];

  var popup = document.createElement('div');
  popup.className = 'ul-social-proof';
  popup.innerHTML = '<div class="ul-social-proof__title"></div><div class="ul-social-proof__text"></div><div class="ul-social-proof__time"></div>';
  document.body.appendChild(popup);

  var idx = 0;
  function showProof() {
    var p = proofs[idx % proofs.length];
    popup.querySelector('.ul-social-proof__title').textContent = '\uD83D\uDC64 ' + p.name;
    popup.querySelector('.ul-social-proof__text').textContent = p.text;
    popup.querySelector('.ul-social-proof__time').textContent = '\u23F0 ' + p.time;
    popup.style.display = 'block';
    idx++;
    setTimeout(function(){ popup.style.display = 'none'; }, 4000);
  }

  setTimeout(function(){
    showProof();
    setInterval(showProof, 14000);
  }, 5000);

  /* ── STICKY ADD TO CART (product pages) ── */
  var atcOriginal = document.querySelector('.product-form__submit, [name="add"]');
  if (atcOriginal) {
    var productName = document.querySelector('.product__title, h1.title');
    var productPrice = document.querySelector('.price__regular .price-item, .price .money');

    var sticky = document.createElement('div');
    sticky.className = 'ul-sticky-atc';
    sticky.innerHTML =
      '<div><div class="ul-sticky-atc__name">' + (productName ? productName.textContent.trim() : '') + '</div>' +
      '<div class="ul-sticky-atc__price">' + (productPrice ? productPrice.textContent.trim() : '') + '</div></div>' +
      '<button class="ul-sticky-atc__btn" onclick="document.querySelector(\'.product-form__submit,[name=add]\').click()">\uD83D\uDED2 A\u00F1adir al carrito</button>';
    document.body.appendChild(sticky);

    var observer = new IntersectionObserver(function(entries) {
      sticky.classList.toggle('visible', !entries[0].isIntersecting);
      sticky.style.display = 'flex';
    }, { threshold: 0.1 });
    observer.observe(atcOriginal);
  }

  /* ── URGENCY STOCK MESSAGE ── */
  var urgencyTargets = document.querySelectorAll('.product-form__submit, .product__info-container');
  if (urgencyTargets.length) {
    var urgency = document.createElement('div');
    urgency.className = 'ul-urgency';
    urgency.innerHTML = '<div class="ul-urgency__dot"></div><p class="ul-urgency__text">\u26A0\uFE0F <strong>Solo quedan 8 unidades</strong> en stock. Pide ahora para recibirlo ma\u00F1ana.</p>';
    var form = document.querySelector('.product-form__submit');
    if (form && form.parentNode) form.parentNode.insertBefore(urgency, form);
  }

})();
